<template>
  <div>
    <div
      class="w-full h-full flex flex-col items-center text-center p-3 mt-[248px]"
    >
      <Icon name="FilledCircleCheck" :size="38" class="mb-6" />

      <div
        class="font-primary font-semibold text-[34px] leading-[38px] text-gray-800 mb-[18px]"
      >
        You're signed in
      </div>

      <div
        class="font-primary text-[17px] leading-[26px] text-gray-800 mb-[46px]"
      >
        <div>You should now be signed into the Dacr desktop app.</div>
        <div>Feel free to close this page!</div>
      </div>

      <div class="font-primary text-[14px] leading-[23px] text-gray-800">
        Need help? Contact
        <a
          class="text-link"
          href="https://help.dacr.com/hc/en-us/requests/new"
          target="_top"
        >
          support
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@dacr/ui'
</script>
